import * as t from 'io-ts';
import { MetadataUser } from './metadata-user.type';

const MetadataItem = t.type(
  {
    value: t.union([t.string, t.boolean, MetadataUser]),
    type: t.string,
  },
  'MetadataItem',
);

type MetadataItem = t.TypeOf<typeof MetadataItem>;
export { MetadataItem };
